import ForgotPassword from "./ForgotPassword";

export const forgetPasswordRoute = (data) => [
  {
    path: "/forgot-password",
    title: "Forgot Password",
    component: ForgotPassword,
    layout: "auth",
    routeType: "auth",
  },
];
